module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "noindent2"
  }, [_c('a', {
    attrs: {
      "id": "ch00_fm01"
    }
  }), _c('a', {
    attrs: {
      "id": "page_tpb1"
    }
  }), _vm._v("After leaving school at fifteen, "), _c('strong', [_vm._v("Mo Hayder")]), _vm._v(" worked as a barmaid, security guard, film-maker, hostess in a Tokyo club, educational administrator and teacher of English as a foreign language in Asia. She has an MA in creative writing from Bath Spa University, where she now teaches.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent2a"
  }, [_vm._v("She is the author of "), _c('em', [_vm._v("Birdman, The Treatment")]), _vm._v(", which won the 2001 WH Smith Thumping Good Read Award, and "), _c('em', [_vm._v("Tokyo")]), _vm._v(", which was shortlisted for the CWA Gold and Steel Dagger Awards for Novels of the Year, 2004. They are published in paperback by Bantam Books.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "textcenterw"
  }, [_c('span', {
    staticClass: "weblink"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "http://www.booksattransworld.co.uk",
      "target": "_blank"
    }
  }, [_vm._v("www.booksattransworld.co.uk")])])]), _vm._v(" "), _c('hr')])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31f6c4f4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch00_fm01.vue
// module id = 63
// module chunks = 0